export default __webpack_public_path__ + "static/media/payment-details.9f00fe45.svg";